export default "__VITE_ASSET__530a40be__"